import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login'

import mappingRouter from './modules/shared'
import incentiveRouter from './modules/incentive'
import eventRouter from './modules/event'
import storePageRouter from './modules/storePage'
import marketInsightRouter from './modules/marketInsight'
import unassignedStoreRouter from './modules/unassignedStore'
import pendingEventStoreRouter from './modules/pendingEventStore'
import storeExpansionRouter from './modules/storeExpansion'
import storeMaintainRouter from './modules/storeMaintain'
import overdueNoFollowedRouter from './modules/overdueNoFollowed'
import pendingReviesRouter from './modules/pendingRevies'
import salesDistributionRouter from './modules/salesDistribution'
import visitPlanRouter from './modules/visitPlan'

// 路由懒加载，写成函数的格式 webpack打包的时候，
// 看到这个标识就不会不加载这个js文件
// webpackChunkName 用来 指明 打包后 生成的文件名
// const Search = () => import(/* webpackChunkName: 'Search' */ '@/views/Search')
// const SearchResultList = () => import(/* webpackChunkName: 'SearchResultList' */ '@/views/Search/ResultList')
// const UserEdit = () => import(/* webpackChunkName 'UserEdit' */ '@/views/UserEdit')
// const Chat = () => import(/* webpackChunkName 'Chat' */ '@/views/Chat')
// const ArticleDetail = () => import(/* webpackChunkName 'ArticleDetail' */'@/views/Article/id')

// 首页
const HomePage = () => import('@/views/HomePage')
const Schedule = () => import('@/views/HomePage/schedule')

const StoreMap = () => import('@/views/StoreMap')
const MapSearch = () => import('@/views/Search/mapSearch')

// 门店
const ChooseLocation = () => import('@/components/chooseLocation.vue')
// 我的
const User = () => import('@/views/User')
Vue.use(VueRouter)

const routes = [
  {
    // 根路径 的 重定向
    path: '/',
    redirect: '/homePage'// 重定向
  },
  {
    path: '/schedule',
    component: Schedule
  },
  {
    // 登录页
    path: '/login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/homePage',
    component: HomePage,
    meta: {
      title: 'index'
    }
  },
  ...mappingRouter,
  ...incentiveRouter,
  ...eventRouter,
  ...storePageRouter,
  ...marketInsightRouter,
  ...unassignedStoreRouter,
  ...pendingEventStoreRouter,
  ...storeExpansionRouter,
  ...storeMaintainRouter,
  ...overdueNoFollowedRouter,
  ...pendingReviesRouter,
  ...salesDistributionRouter,
  ...visitPlanRouter,
  {
    path: '/storeMap',
    component: StoreMap,
    meta: {
      title: 'Store Map'
    }
  },
  {
    path: '/mapSearch',
    component: MapSearch,
    meta: {
      title: 'Map Search'
    }
  },
  {
    path: '/user',
    component: User,
    meta: {
      title: 'My'
    }
  },
  {
    path: '/chooseLocation',
    component: ChooseLocation,
    meta: {
      title: 'ChooseLocation'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { y: 0 }
    }
  }
  // scrollBehavior: () => ({ y: 0 })
})

router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    gtag('config', 'G-XTF0LRE0J4', {
      page_path: to.fullPath,
      page_title: to.meta.title || 'untitled_page'
    })
  } else {
    console.log('gtag not loaded, skipping analytics tracking')
  }
})

// 路由重复跳转问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
